import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Switch, Redirect, Route, withRouter } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

import PublicRoute from '../components/PublicRoute';
import PrivateRoute from '../components/PrivateRoute';
import SideMenu from '../containers/SideMenu';
import Login from '../containers/Login';
import NotFound from '../views/NotFound';
import Users from '../containers/UsersContainer';
import NewUser from '../containers/NewUserContainer';
import EditUser from '../containers/EditUserContainer';
import ShowUser from '../containers/ShowUserContainer';
import Paychecks from '../containers/PaychecksContainer';
import NewPaycheck from '../views/Paychecks/NewPaycheck';
import ShowPaycheck from '../containers/ShowPaycheckContainer';
import Admins from '../containers/AdminsContainer';
import ShowAdmin from '../containers/ShowAdminContainer';
import EditAdmin from '../containers/EditAdminContainer';
import NewAdmin from '../containers/NewAdminContainer';
import Profile from '../containers/ProfileContainer';

import isAuthenticated from '../utils/session';

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    width: '100%',
  },
  navIconHide: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
});

class AppNavigation extends PureComponent {
  constructor() {
    super();

    this.state = {
      mobileOpen: false,
    };

    this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
  }

  handleDrawerToggle() {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  }

  render() {
    const { classes } = this.props;
    const { mobileOpen } = this.state;

    return (
      <div className={classes.root}>
        { isAuthenticated() && <SideMenu isOpen={mobileOpen} onClose={this.handleDrawerToggle} /> }
        <main className={classes.content}>
          { isAuthenticated() && <div className={[classes.toolbar, classes.navIconHide]}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={this.handleDrawerToggle}
              className={classes.navIconHide}
            >
              <MenuIcon />
            </IconButton>
          </div> }
          <Switch>
            <Redirect exact from='/' to='/paychecks?page=1' />
            <PublicRoute exact path='/login' component={Login} />
            <PublicRoute exact path='/404' component={NotFound} />
            <PrivateRoute can='read' on='User' exact path='/users' component={Users} />
            <PrivateRoute can='create' on='User' exact path='/users/new' component={NewUser} />
            <PrivateRoute can='update' on='User' exact path='/users/:id/edit' component={EditUser} />
            <PrivateRoute can='read' on='User' exact path='/users/:id' component={ShowUser} />
            <PrivateRoute can='read' on='Paycheck' exact path='/paychecks' component={Paychecks} />
            <PrivateRoute can='create' on='Paycheck' exact path='/paychecks/new' component={NewPaycheck} />
            <PrivateRoute can='read' on='Paycheck' exact path='/paychecks/:id' component={ShowPaycheck} />
            <PrivateRoute can='read' on='Admin' exact path='/admins' component={Admins} />
            <PrivateRoute can='create' on='Admin' exact path='/admins/new' component={NewAdmin} />
            <PrivateRoute can='update' on='Admin' exact path='/admins/:id/edit' component={EditAdmin} />
            <PrivateRoute can='read' on='Admin' exact path='/admins/:id' component={ShowAdmin} />
            <PrivateRoute can='update' on='Profile' exact path='/profile' component={Profile} />
            <Route component={NotFound} />
          </Switch>
        </main>
      </div>
    );
  }
}

export default compose(
  withRouter,
  withStyles(styles),
)(AppNavigation);

AppNavigation.propTypes = {
  classes: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/navigation/index.js